<template>
  <div>
    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.name'" rules="min:2" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_CONTACT_DETAILS.NAME')"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.name"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.phone'" rules="min:2" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_CONTACT_DETAILS.PHONE')"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.phone"
        ></v-text-field>
      </validation-provider>
    </div>

    <div class="flex-100">
      <address-details v-model="model.address" :path="path + '.address'"></address-details>
    </div>

    <div class="flex-gt-sm-50 flex-100 px-2">
      <validation-provider tag="div" :name="path + '.email'" rules="min:2" v-slot="{ errors }">
        <v-text-field
            :dark="compColor.isInDarkMode"
            :color="compColor.primeColor"
            :dense="denseFields"
            :label="$t('COMPONENT_ACCOUNT.EMAIL')"
            outlined
            :hide-details="!errors || errors.length <= 0"
            :error-messages="errors[0]"
            v-model="model.email"
        ></v-text-field>
      </validation-provider>
    </div>
  </div>
</template>

<script>
import addressDetails from './AddressDetails'

export default {
  name: 'ContactDetails',
  components: {
    addressDetails
  },
  props: {
    value: {
      type: Object,
      default: () => ({ address: {} })
    },
    path: {
      type: String
    }
  },
  data () {
    return {
      model: {}
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    }
  }
}
</script>
